import { Heading, Section } from 'components'
import React from 'react'
import { Card } from 'components'
import * as Styles from './Features.module.css'

const FeaturesBlock = ({ heading, kicker, features }) => {
  return (
    <Section>
      <div className={Styles.sectionWrapper}>
        <div className={Styles.sectionHeader}>
          <Heading type="kicker">{kicker}</Heading>
          <Heading>{heading}</Heading>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 items-top gap-16">
          {features.map((feature, index) => (
            <Card key={index} data={feature} />
          ))}
        </div>
      </div>
    </Section>
  )
}

export default FeaturesBlock
